import { useElementSize, useListState } from '@mantine/hooks';
import { FC, useEffect, useState } from 'react';
import { ActionIcon, Group } from '@mantine/core';
import { IconEye, IconTrash } from '@tabler/icons';
import { i18n } from '@lingui/core';
import { FileDetails, FileS } from '../../../Service/FileS';
import { useJwtClaims } from '../../../Service/Context/AuthContext';
import SkeletonItems from '../../../Atoms/SkeletonItems';
import EmptyText from '../../../Atoms/EmptyText';
import BookitupTable from '../../../Atoms/BookitupTable';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';
import { useModalState } from '../../../Molecules/Dialogs';
import { FileModalDialog } from '../../../Molecules/Dialogs/FileModalDialog';

interface Props {
  lastUpdate: Date;
}

const ProfileFilesTable: FC<Props> = ({ lastUpdate }) => {
  const { profileId } = useJwtClaims();
  const { show, toggle } = useModalState();
  const [files, { setState, remove }] = useListState<FileDetails>([]);
  const [loading, setLoading] = useState(false);
  const [previewFile, setPreviewFile] = useState<any>();
  const { ref, width } = useElementSize();
  const isEmpty = files.length === 0;

  useEffect(() => {
    setLoading(true);
    FileS.getEntityFiles('profiles', profileId.toString())
      .then(setState)
      .finally(() => setLoading(false));
  }, [profileId, setState, lastUpdate]);

  const previewHandler = (file: FileDetails) => {
    setPreviewFile({ ...file, entityType: 'profiles', entityId: profileId });
    toggle();
  };

  const deleteHandler = (idx: number, file: FileDetails) =>
    openDeleteConfirmModal({
      title: i18n._('promomaterial.delete.confirm.head'),
      description: i18n._('promomaterial.delete.confirm'),
      onConfirm: async () => {
        const removed = await FileS.remove('profiles', profileId.toString(), file.fileName);
        if (removed) {
          remove(idx);
        }
        return removed;
      },
    });

  return (
    <>
      <BookitupTable>
        <thead>
          <tr>
            <th style={{ width: width - 200 }}>
              <b>Dateiname </b>
            </th>
            <th> </th>
          </tr>
        </thead>
        <tbody>
          {loading && <SkeletonItems />}
          {!loading && isEmpty && <EmptyText />}
          {files.map((f, idx) => (
            <tr ref={ref} key={f.fileName}>
              <td className="overflow-ellipsis" style={{ maxWidth: width - 100 }}>
                {f.fileName}
              </td>
              <td>
                <Group spacing="xs" position="right">
                  <ActionIcon size="xs" onClick={() => previewHandler(f)}>
                    <IconEye />
                  </ActionIcon>
                  <ActionIcon size="xs" onClick={() => deleteHandler(idx, f)}>
                    <IconTrash />
                  </ActionIcon>
                </Group>
              </td>
            </tr>
          ))}
        </tbody>
      </BookitupTable>
      <FileModalDialog
        show={show}
        toggle={toggle}
        allowDownload
        allowEmailAttachment
        allowEditing
        file={previewFile}
        eventId={undefined}
      />
    </>
  );
};

export default ProfileFilesTable;
